import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { PayerInitialState } from '../../store/models/payerListModel';
import { Payer } from '../models/payer.model';

export function useFindPayer(): any {
  const { allPayers } = useSelector((state: RootState): PayerInitialState =>
      state.payerList);
  const findPayer = (payerId: number): Payer | undefined => {
    return allPayers.find(({ id }: Payer): boolean => id === payerId);
  };

  return findPayer;
}
